import axios from "axios";
import React, { useState } from "react";
import { faTruck, faRoute, faBox, faUndo, faCity } from '@fortawesome/free-solid-svg-icons';
import '../components/style/warehouse.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const InteriorDesignInquiryForm = () => {
  const [Name, setName] = useState("");
  const [Mobile, setMobile] = useState("");
  const [Email, setEmail] = useState("");
  const [Inquiry, setInquiry] = useState("");
  const [Service, setService] = useState("");
  const [Message, setMessage] = useState("");
  const [City, setCity] =useState("")

  const addContact = async (event) => {
    event.preventDefault(); // Prevent form reload on submission

    try {
      if (!Name || !Mobile || !Email || !Service) {
        return alert("All fields except message are required.");
      }

      // Create the payload
      const formData = {
        name: Name,
        phone: Mobile,
        email: Email,
        inquirytype:"Interiar Design",
        service: Service,
        message: Message,
        city:City,
      };
      console.log("response",formData);
      // Make POST request to the API
      const response = await axios.post("https://vrpmpro.com/api/user/inquiry", formData, {
        headers: { "Content-Type": "application/json" },
      });
   
      
      if (response.status === 201) {
        alert(response.data.message || "Inquiry submitted successfully.");
        // Reset form fields
        setName("");
        setMobile("");
        setEmail("");
        setInquiry("");
        setService("");
        setMessage("");
        setCity("");
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error || "Failed to submit inquiry. Try again.";
      alert(errorMessage);
      console.error("Error submitting inquiry:", error);
    }
  };

  return (
    <div className="container my-5">
      <h2 className="text-center mb-4">Interior Design Inquiry Form</h2>
      <form onSubmit={addContact}>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label htmlFor="name" className="form-label">
              Name
            </label>
            <input
              type="text"
              className="form-control"
              id="name"
              placeholder="Enter your name"
              value={Name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className="col-md-6 mb-3">
            <label htmlFor="phone" className="form-label">
              Phone
            </label>
            <input
              type="tel"
              className="form-control"
              id="phone"
              placeholder="Enter your phone number"
              value={Mobile}
              onChange={(e) => setMobile(e.target.value)}
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label htmlFor="email" className="form-label">
              Email
            </label>
            <input
              type="email"
              className="form-control"
              id="email"
              placeholder="Enter your email"
              value={Email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
    
      
          <div className="col-md-6 mb-3">
            <label htmlFor="service" className="form-label">
              Design Type
            </label>
            <select
              className="form-select"
              id="service"
              value={Service}
              onChange={(e) => setService(e.target.value)}
              required
            >
              <option value="">Select a Design Type</option>
              <option value="residential">Residential</option>
              <option value="commercial">Commercial</option>
              <option value="renovation">Renovation</option>
            </select>
          </div>
          </div>
          <div className="row">
          <div className="col-md-6 mb-3">
                     <label htmlFor="city" className="form-label">
                       <FontAwesomeIcon icon={faCity} className="me-2 text-secondary" />
                       City
                     </label>
                     <input
                       type="text"
                       className="form-control"
                       id="city"
                       placeholder="Enter your City"
                       value={City}
                       onChange={(e) => setCity(e.target.value)}
                       required
                     />
                   </div>
        </div>
        <div className="mb-3">
          <label htmlFor="message" className="form-label">
            Message
          </label>
          <textarea
            className="form-control"
            id="message"
            rows="4"
            placeholder="Enter additional details"
            value={Message}
            onChange={(e) => setMessage(e.target.value)}
          ></textarea>
        </div>
        <button type="submit" className="btn btn-danger">
          Submit Inquiry
        </button>
      </form>

      <div className="container-fluid mt-5">
      <div className="row">
        <div className="col-md-6 service-box bg-dark-blue">
          <FontAwesomeIcon icon={faTruck} size="2x" />
          <h5>Carrier &amp; Parcel Management</h5>
          <p>Market leading e-commerce parcel delivery offering single and multi carrier solutions</p>
        </div>
        <div className="col-md-6 service-box bg-light-green">
          <FontAwesomeIcon icon={faRoute} size="2x" />
          <h5>Intelligent Routing Technology</h5>
          <p>Labels, tracking and reporting for all major carriers, marketplaces and e-commerce platforms</p>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 service-box bg-dark-green">
          <FontAwesomeIcon icon={faBox} size="2x" />
          <h5>Business Fulfillment</h5>
          <p>Fully flexible pick &amp; pack solutions for B2C B2B e-commerce and subscription clients</p>
        </div>
        <div className="col-md-6 service-box bg-blue">
          <FontAwesomeIcon icon={faUndo} size="2x" />
          <h5>Returns Management</h5>
          <p>Market leading returns management with multiple services available to all clients</p>
        </div>
      </div>
      <div className="row welcome-section">
        <div className="col-md-6">
          <h1>
            WELCOME TO <span>DREAMSSTATES</span>
          </h1>
          <p>
          Dreamestate is a BOON to Buyer, Seller, and Tenant, anywhere in Bharat, The Great, with no broker and broker- troubles. We present facts of the property without exaggeration or diminution. Property details, encumbrances, surroundings, merits, demerits, if any etc are displayed and disseminated to the client after strict scrutiny. 

</p>
          <p>
          Buyer and seller can contact each other directly also without hindrance. If need be, we will help. Our presentation format is clear, crypt and precise for you to decide easily and with least effort. Any seller, buyer or prospective tenant can contact us without any hesitation. We are here to help you..
          </p>
        </div>
        <div className="col-md-6">
          <img
            src="https://storage.googleapis.com/a1aa/image/ehGxsmp1Zcy4O6AU1hz4h6kv1mHzXOej4ie6rxuihdGbPTunA.jpg"
            alt="Delivery person in blue uniform talking to a customer"
            className="img-fluid"
            width="500"
            height="300"
          />
        </div>
      </div>
    </div>
    </div>
  );
};

export default InteriorDesignInquiryForm;
